import PropTypes from 'prop-types';
import { filterTypes } from './filterHelpers';

export const betweenPropShape = PropTypes.shape({
  currency: PropTypes.shape({
    code: PropTypes.string.isRequired,
    symbol: PropTypes.string.isRequired
  }),
  printStyle: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
});

export const filterOptionPropTypes = PropTypes.shape({
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  quantity: PropTypes.number,
  active: PropTypes.bool.isRequired,
  isFoldedByDefault: PropTypes.bool,
  range: PropTypes.shape({
    left: betweenPropShape.isRequired,
    right: betweenPropShape.isRequired
  }),
  images: PropTypes.arrayOf(PropTypes.shape({
    url: PropTypes.string.isRequired
  }))
});

export const filtersPropTypes = PropTypes.arrayOf(
  PropTypes.shape({
    selectedBetween: PropTypes.shape({
      left: betweenPropShape.isRequired,
      right: betweenPropShape.isRequired
    }),
    limitBetween: PropTypes.shape({
      left: betweenPropShape.isRequired,
      right: betweenPropShape.isRequired
    }),
    limitByFilterBetween: PropTypes.shape({
      left: betweenPropShape,
      right: betweenPropShape
    }),
    currentFormBetween: PropTypes.shape({
      left: betweenPropShape.isRequired,
      right: betweenPropShape.isRequired
    }),
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.arrayOf(filterOptionPropTypes).isRequired,
    type: PropTypes.oneOf(Object.values(filterTypes)).isRequired,
    maxValue: PropTypes.number
  })
);
